var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCliqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20C1.45 20 0.979333 19.8043 0.588 19.413C0.196 19.021 0 18.55 0 18V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H11L16 5V18C16 18.55 15.8043 19.021 15.413 19.413C15.021 19.8043 14.55 20 14 20H2ZM2 18H14V6H10V2H2V18ZM8 17C9.11667 17 10.0627 16.6083 10.838 15.825C11.6127 15.0417 12 14.1 12 13V9H10V13C10 13.55 9.80833 14.021 9.425 14.413C9.04167 14.8043 8.56667 15 8 15C7.45 15 6.97933 14.8043 6.588 14.413C6.196 14.021 6 13.55 6 13V7.5C6 7.35 6.05 7.229 6.15 7.137C6.25 7.04567 6.36667 7 6.5 7C6.65 7 6.771 7.04567 6.863 7.137C6.95433 7.229 7 7.35 7 7.5V13H9V7.5C9 6.8 8.75833 6.20833 8.275 5.725C7.79167 5.24167 7.2 5 6.5 5C5.8 5 5.20833 5.24167 4.725 5.725C4.24167 6.20833 4 6.8 4 7.5V13C4 14.1 4.39167 15.0417 5.175 15.825C5.95833 16.6083 6.9 17 8 17ZM2 2V6V2V18V2Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliqIcon);
export default __webpack_public_path__ + "static/media/CliqIcon.8a8b19657e17f46b35cff559070cf3ac.svg";
export { ForwardRef as ReactComponent };